import styled from "styled-components"
import { colors } from '../../../helpers/consts'

export const Section = styled.section`
  width: 100%;
  padding: 2rem 0;

  h2 {
    @media (min-width: 62em) {
      max-width: 66rem;
    }
  }

  @media (min-width: 48em) {
    padding: 3rem 0;
  }

  @media (min-width: 62em) {
    padding: 8rem 0;
  }

  @media (min-width: 112em) {
    padding: 12.6rem 0;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  > p {
    max-width: 44rem;
  }

  @media (min-width: 62em) {
    align-items: flex-start;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${({ color }) => (color ? color : colors.darkBlue)};
  color: ${({ dark }) => (dark ? colors.darkBlue : colors.white)};
  width: 22rem;
  min-height: 24rem;
  box-shadow: 0px 15px 31px rgba(13, 12, 82, 0.25);
  border-radius: 8px;
  padding: 2rem;
  margin: 1rem;

  img {
    margin-bottom: 2.6rem;
    max-height: 9rem;
    min-height: 9rem;

    @media (min-width: 48em) {
      max-height: 11rem;
      min-height: 11rem;
    }

    @media (min-width: 62em) {
      max-height: 13.2rem;
      min-height: 13.2rem;
    }
  }

  @media (min-width: 48em) {
    padding: 3rem 2rem;
    width: 27rem;
    min-height: 32rem;
  }

  @media (min-width: 62em) {
    padding: 5rem 3.6rem;
    min-height: 37.4rem;
    width: 29.8rem;
    margin: 1rem 0;

    :nth-of-type(2) {
      margin: 1rem 2rem;
    }
  }
`

export const SectionContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  flex-direction: column;

  @media (min-width: 48em) {
    margin-bottom: 4rem;
    flex-direction: row;
  }

  @media (min-width: 62em) {
    margin-bottom: 6rem;
    justify-content: space-between;
  }

  @media (min-width: 112em) {
    margin-bottom: 8rem;
  }
`

export const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 500;
  color: ${colors.darkBlue};
  text-align: center;
  margin-bottom: 1rem;

  @media (min-width: 48em) {
    font-size: 2.3rem;
    margin-bottom: 2rem;
  }

  @media (min-width: 62em) {
    text-align: left;
    font-size: 2.7rem;
    max-width: 66rem;
    margin-bottom: 3.2rem;
  }
`

export const CardHeading = styled.p`
  font-size: 1.8rem;
  font-weight: 500;

  @media (min-width: 48em) {
    font-size: 2.2rem;
  }

  @media (min-width: 62em) {
    font-size: 2.7rem;
  }
`

export const CardText = styled.span`
  font-size: 1.6rem;
  font-weight: 300;

  @media (min-width: 48em) {
    font-size: 1.8rem;
  }

  @media (min-width: 62em) {
    font-size: 2rem;
  }
`
